import React, { useState } from "react";
import UIButton from "../../../../../globalComponents/UIComponents/UIButton";
import { useShopContext } from "../../../context/ShopContext";

import './style.scss';

const className = 'get-prize-modal';

export default ({ prize, title, available, $locale, priceStr }) => {

    const { createOrder, loadingShopData } = useShopContext();

    const [orderCreated, setOrderCreated] = useState(false);

    const handleCreateOrder = async () => {
        const response = await createOrder(prize.id);
        setOrderCreated(!!response?.id);
    };

    const photo = prize.images?.[0]?.previewFileUrl;

    return <div className={className}>
        {orderCreated ? <>
            <div className={`${className}-header`}>{$locale.get('shop.orderSuccess')}</div>
            <div className={`${className}-description`}>{$locale.get('shop.orderSuccess.description')}</div>
        </> : <>
            <div className={`${className}-header`}>{$locale.get('shop.buyFor')} {priceStr}?</div>
            <div className={`${className}-card`}>
                <div className={`${className}-card-image-container`}>
                    {photo && <img src={photo} alt={title} />}
                </div>
                <div className={`${className}-card-info-container`}>
                    <div className={`${className}-card-available`}>{$locale.get('shop.available')} {available} / {prize.totalLimit}</div>
                    <div className={`${className}-card-title`}>{title}</div>
                </div>
            </div>
            <UIButton fullWidth color="primary" onClick={handleCreateOrder} disabled={loadingShopData}>{$locale.get('shop.getPrize')}</UIButton>
        </>}
    </div>
}